module.exports = __webpack_public_path__ + "static/media/promotionBottom.3e4f868c.svg";